import SrCheckbox from "./SrCheckbox.vue";

SrCheckbox.install = function(Vue) {
  Vue.component(SrCheckbox.name, SrCheckbox);
};

export default SrCheckbox;


// WEBPACK FOOTER //
// ./packages/SrCheckbox/index.js